import Card from "app/components/Card";
import CircularLoader from "app/components/CircularLoader";
import ChevronDownIcon from "app/components/Icons/ChevronDownIcon";
import { actions as memberActions } from "app/containers/Features/components/MemberSelection/redux/slice";
import ProjectFilter from "app/containers/Features/containers/Home/components/TicketFilters/ProjectFilter";
import { useLastActivities } from "app/containers/Features/containers/Home/hooks/useLastActivities";
import { useProjectsProgress } from "app/containers/Features/containers/Home/hooks/useProjectsProgress";
import { selectSelectedTeam } from "app/redux/selector";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ActivityItemContent from "./ActivityItemContent";
import { ActivityGroupSkeleton } from "./ActivitySkeleton";
import { IWorkspaceTeams } from "app/types";

export default function LastActivitiesWidget() {
  const {
    groupedActivities,
    selectedProjectIds,
    setSelectedProjectIds,
    collapsedGroups,
    toggleGroup,
    homeProjectDetails,
    projectOptions,
    scrollRef,
    handleScroll,
    hasMore,
  } = useLastActivities();

  const { isLoading, combinedProjects } = useProjectsProgress();
  const shouldUseTallHeight = combinedProjects.length > 1;

  const selectedTeam = useSelector(selectSelectedTeam);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (selectedTeam?._id) {
      dispatch(
        memberActions.fetchTeamMembersList({
          id: selectedTeam._id,
          callback() {},
        }),
      );
    }
  }, [dispatch, selectedTeam?._id]);

  return (
    <Card
      className={`flex flex-1 flex-col gap-4 overflow-hidden rounded-md border border-gray-100 bg-white p-6 shadow-none ${
        shouldUseTallHeight ? "h-[454px]" : "h-[362px]"
      }`}
    >
      <div className="flex h-7 items-center justify-between gap-4">
        <h2 className="text-sm font-medium leading-[21px] text-black">
          Last activities
        </h2>
        <div className="mr-2">
          <ProjectFilter
            selectedIds={selectedProjectIds}
            onUpdate={setSelectedProjectIds}
            options={projectOptions}
            alignDropdownRight={true}
          />
        </div>
      </div>

      <div
        className="flex flex-1 min-h-0 flex-col gap-2 overflow-y-auto pr-2"
        ref={scrollRef}
        onScroll={handleScroll}
      >
        <>
          {isLoading  ? (
            <>
              <ActivityGroupSkeleton />
              <ActivityGroupSkeleton />
            </>
          ) : (
            groupedActivities.map((group, idx) => (
              <div key={idx} className="flex flex-col gap-4">
                <div
                  className="flex cursor-pointer items-center gap-2"
                  onClick={() => toggleGroup(group.group)}
                >
                  <div
                    className={`transition-transform duration-200 ${collapsedGroups[group.group] ? "-rotate-90" : ""}`}
                  >
                    <ChevronDownIcon size={16} color="#79808A" />
                  </div>
                  <span className="text-sm font-medium text-secondary">
                    {group.group}
                  </span>
                </div>

                {!collapsedGroups[group.group] && (
                  <div className="flex flex-col gap-4">
                    {group.items.map((item, i) => (
                      <ActivityItemContent
                        key={i}
                        item={item}
                        homeProjectDetails={homeProjectDetails}
                        selectedTeam={selectedTeam as IWorkspaceTeams}
                      />
                    ))}
                  </div>
                )}
              </div>
            ))
          )}
          {isLoading && groupedActivities.length > 0 && hasMore && (
            <div className="py-2 text-center flex justify-center">
              <CircularLoader size="sm" />
            </div>
          )}
        </>
      </div>
    </Card>
  );
}
